module.exports = __webpack_public_path__ + "static/img/page47.54c5250.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page47.jpg
// module id = QmXm
// module chunks = 0